import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { BottomNav } from "@/components/BottomNav";
import { ScrollToTop } from "@/components/ScrollToTop";
import { BadgeCelebration } from "@/components/BadgeCelebration";
import { RulesGate } from "@/components/RulesGate";

import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useDbSync } from "@/hooks/useDbSync";
import { useUserStatsRealtime } from "@/hooks/useUserStats";
import { useMatchStatusTicker } from "@/hooks/useMatchStatusTicker";
import { usePrefetchLeagues } from "@/hooks/useLeaguesDb";
import logo from "@/assets/logo.png";

export const Route = createFileRoute("/_app")({
  component: AppLayout,
});

function AppLayout() {
  useDbSync();
  useUserStatsRealtime();
  useMatchStatusTicker();
  const { user, loading } = useAuth();
  usePrefetchLeagues(user?.id);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate({ to: "/login" });
    }
  }, [loading, user, navigate]);

  if (loading || !user) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <img src={logo} alt="" className="h-48 w-48 animate-pulse object-contain" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <main className="mx-auto max-w-6xl px-4 pt-6 pb-24">
        <Outlet />
      </main>
      <BottomNav />
      <BadgeCelebration />
      <RulesGate />
      <ScrollToTop />

    </div>
  );
}
